import { Head } from "@inertiajs/react"
import { SonarLayout } from "@/components/sonar"
import { Overview } from "@/components/overview"
import type { CashCollectionsData } from "@/components/cash-collections"
import type { SalesReportData } from "@/components/sales-report"
import type { DSDCenterData } from "@/components/dsd-center"

interface OverviewPageProps {
  cashCollections: CashCollectionsData
  salesReport: SalesReportData
  dsdCenter: DSDCenterData
}

export default function OverviewPage({ cashCollections, salesReport, dsdCenter }: OverviewPageProps) {
  return (
    <>
      <Head title="Overview">
        <meta
          name="description"
          content="DSD's monthly financial home — True Sales, cash collected, net cash and DSD Center utilisation rolled up at a glance."
        />
        <meta property="og:title" content="Overview" />
        <meta
          property="og:description"
          content="DSD's monthly financial home — True Sales, cash collected, net cash and DSD Center utilisation rolled up at a glance."
        />
      </Head>
      <SonarLayout>
        <Overview cashCollections={cashCollections} salesReport={salesReport} dsdCenter={dsdCenter} />
      </SonarLayout>
    </>
  )
}
